import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const QUICK_LINKS = 'links'
export const MEDIA_LIBRARY = 'mediaLibrary'
export const LANGUAGE = 'language'
export const PREFERENCES = 'Preferences'
export const DARK_MODE = 'darkMode'
export const LIGHT_MODE = 'lightMode'
export const ACCOUNT = 'account'
export const MY_ACCOUNT = 'myAccount'
export const LOGOUT = 'logout'
export const LOGIN = 'login'
export const CURRENT_LANGUAGE = 'current language'

export default {
  [PORTUGUESE]: {
    [QUICK_LINKS]: 'Links Rápidos',
    [MEDIA_LIBRARY]: 'Biblioteca de Mídia',
    [LANGUAGE]: 'Idioma',
    [PREFERENCES]: 'Preferências',
    [DARK_MODE]: 'Modo Escuro',
    [LIGHT_MODE]: 'Modo Claro',
    [ACCOUNT]: 'Conta',
    [MY_ACCOUNT]: 'Minha Conta',
    [LOGOUT]: 'Sair',
    [LOGIN]: 'Acessar',
    [CURRENT_LANGUAGE]: 'Português',
  },

  [ENGLISH]: {
    [QUICK_LINKS]: 'Quick Links',
    [MEDIA_LIBRARY]: 'Media Library',
    [LANGUAGE]: 'Language',
    [PREFERENCES]: 'Preferences',
    [DARK_MODE]: 'DarkMode',
    [LIGHT_MODE]: 'LightMode',
    [ACCOUNT]: 'Account',
    [MY_ACCOUNT]: 'My Account',
    [LOGOUT]: 'Logout',
    [LOGIN]: 'Login',
    [CURRENT_LANGUAGE]: 'English',
  },

  [SPANISH]: {
    [QUICK_LINKS]: 'Links Rápidos',
    [MEDIA_LIBRARY]: 'Mediateca',
    [LANGUAGE]: 'Idioma',
    [PREFERENCES]: 'Preferencias',
    [DARK_MODE]: 'Modo Oscuro',
    [LIGHT_MODE]: 'Modo Claro',
    [ACCOUNT]: 'Cuenta',
    [MY_ACCOUNT]: 'Mi Cuenta',
    [LOGOUT]: 'Cerrar sesión',
    [LOGIN]: 'Acceso',
    [CURRENT_LANGUAGE]: 'Español',
  },
}
